module.exports = __webpack_public_path__ + "img/interview-dp.dc646788.svg";